export default __webpack_public_path__ + "static/media/word.18fd9cf4.png";